/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
  Textarea,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useAddCustomNotification } from '../hooks/useAddCustomNotification';
import { useCustomNotificationById } from '../hooks/useCustomNotificationById';
import { useUpdateCustomNotification } from '../hooks/useUpdateCustomNotification';

function CostumeNotificationForm({ editId, onSuccess, setSelectedId }) {
  const id = editId?._id;
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      name: '',
      details: '',
    },
  });

  const {
    data,
    isLoading: isIdLoading,
    isError,
  } = useCustomNotificationById(id);

  useEffect(() => {
    if (data?.data?.result) {
      reset({
        name: data.data.result.name,
        details: data.data.result.details,
      });
    }
  }, [data, reset]);

  const createMutation = useAddCustomNotification({
    onSuccess: () => {
      reset();
      onSuccess?.();
    },
  });
  const updateMutation = useUpdateCustomNotification({
    onSuccess: () => {
      reset();

      setSelectedId(null);
      onSuccess?.();
    },
  });

  const submitHandler = (formData) => {
    if (id) {
      updateMutation.mutate({ id: id, ...formData });
      return;
    }
    createMutation.mutate(formData);
  };

  const isLoading =
    createMutation.isPending || updateMutation.isPending || isIdLoading;

  const cardBg = useColorModeValue('white', 'gray.800');
  const cardShadow = useColorModeValue(
    'rgba(0, 0, 0, 0.35) 0px 5px 15px',
    'rgba(0, 0, 0, 0.6) 0px 5px 15px',
  );

  return (
    <Box w="100%" mt={6} display="flex" justifyContent="center">
      <Card
        w="100%"
        maxW="800px"
        rounded="xl"
        bg={cardBg}
        boxShadow={cardShadow}
      >
        <CardBody p={6}>
          <form onSubmit={handleSubmit(submitHandler)}>
            <VStack spacing={6} align="stretch">
              <FormControl isInvalid={!!errors.name}>
                <FormLabel fontWeight="bold">
                  Name{' '}
                  <Text as="span" color="red.500">
                    *
                  </Text>
                </FormLabel>
                <Input
                  placeholder="Enter Name"
                  {...register('name', {
                    required: 'Name is required',
                  })}
                />
                {errors.name && (
                  <Text color="red.500" fontSize="13px" mt={1}>
                    {errors.name.message}
                  </Text>
                )}
              </FormControl>

              <FormControl isInvalid={!!errors.details}>
                <FormLabel fontWeight="bold">
                  Details{' '}
                  <Text as="span" color="red.500">
                    *
                  </Text>
                </FormLabel>
                <Textarea
                  placeholder="Enter Details"
                  rows={6}
                  resize="vertical"
                  {...register('details', {
                    required: 'Details are required',
                  })}
                />
                {errors.details && (
                  <Text color="red.500" fontSize="13px" mt={1}>
                    {errors.details.message}
                  </Text>
                )}
              </FormControl>

              <Flex justify="flex-end" mt={4}>
                <Button
                  type="submit"
                  colorScheme="blue"
                  isLoading={isLoading}
                  px={8}
                >
                  {editId ? 'Update' : 'Submit'}
                </Button>
              </Flex>
            </VStack>
          </form>
        </CardBody>
      </Card>
    </Box>
  );
}

export default CostumeNotificationForm;
